import { useFastCommentsCount } from '@components/FastCommentWidget';
import { Badge } from '@simplywallst/ui-core';

interface Props {
  commentKey: string;
}

const CommentCount = ({ commentKey }: Props) => {
  const { commentCount } = useFastCommentsCount(commentKey);
  return commentCount > 0 ? <Badge>{commentCount}</Badge> : null;
};

export default CommentCount;
